import React from "react";

import { AnswerTypeEnum } from "../../../../graphql/generated/definitions";

import { QuestionProps } from "./types/QuestionProps";

const QuestionHiddenInputs: React.FC<QuestionProps & { type: AnswerTypeEnum }> =
  ({ register, path, question, type }) => {
    return (
      <>
        <input
          type="hidden"
          value={type}
          readOnly
          {...register(`${path}.type` as const)}
        />
        <input
          type="hidden"
          value={question.id}
          readOnly
          {...register(`${path}.questionId` as const)}
        />
      </>
    );
  };

export default React.memo(QuestionHiddenInputs);
